import { RegionalDomain } from "src/config/BartLambdaConfig";

export type RegistrationsLoadingState = "not-started" | "loading" | "loaded";

export enum ModalMode {
  CREATE = "create", // Creating a new ARD from scratch
  EDIT = "edit", // Modifying an existing ARD
  DUPLICATE = "duplicate", // Creating a new ARD based on an existing one
}

export type ArdRegionMap = Map<string, RegionalDomain>;
